/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  return questionnaire.map(question => {
    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
}) {
  try {
    let saveQuestionnaire = false;

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('INFORMATION - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("INFORMATION - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('INFORMATION - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };